export enum ECcontroller3dMouseEvent {
  mousedown = 'mousedown',
  mousemove = 'mousemove',
  mouseup = 'mouseup'
}
